import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
  Container,
  Grid,
  Typography,
  TextField,
  CircularProgress,
} from "@material-ui/core";
import { fetchConToken } from "../../../helpers/fetch";
import {
  setActiveStep,
  setAfiliadoSeleccionado,
  cleanAfiliadoSeleccionado,
} from "../../../actions/autorizaciones/Autorizaciones";
import { BUSCADOR_CENTRAL, STEPPER_AUTORIZACIONES } from "../../../utils/constants";
import { handleErrorApi } from "../../../helpers/randoms";
import { STEPPER_INTEGRACION } from "../../Discapacidad/data/constants";
import {
  cleanAfiliadoSeleccionadoDiscapacidad,
  setActiveStepDiscapacidad,
  setAfiliadoSeleccionadoDiscapacidad,
} from "../../../actions/discapacidad/discapacidadActions";
import { cleanAfiliadoSeleccionadoAdicciones, setActiveStepAdicciones, setAfiliadoSeleccionadoAdicciones } from "../../../actions/adicciones/adiccionesActions";
import { STEPPER_ADICCIONES } from "../../adicciones/data/constants";

export const AutorizacionesBuscador = (props) => {
  const { afiliadoTemp } = props;
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);

  const cargando = open && options.length === 0;
  const [textoBuscado, setTextoBuscado] = useState("");
  const { tipoBusqueda = "Todos", altaBaja = "Todos" } = props;
  const dispatch = useDispatch();

  const handleInputChange = (e) => {
    let typingTimer = null;
    if (e.target.value.length >= BUSCADOR_CENTRAL.CARACTERES_MINIMOS_AFILIACIONES) {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(() => {
        setTextoBuscado(e.target.value);
      }, BUSCADOR_CENTRAL.MILISEG_SIN_CAMBIOS);
    } else {
      limpiarComponente();
    }
  };

  const handleAfiliadoSeleccionado = (afiliado) => {
    if (!props.liquidaciones) {
      if (!!afiliado) {
        if (props.integracion) {
          dispatch(setActiveStepDiscapacidad(STEPPER_INTEGRACION.DATOS_AFILIADO));
          dispatch(setAfiliadoSeleccionadoDiscapacidad(afiliado));
        }
        else if (props.adicciones) {
          dispatch(setActiveStepAdicciones(STEPPER_ADICCIONES.DATOS_AFILIADO));
          dispatch(setAfiliadoSeleccionadoAdicciones(afiliado));
        }
        else {
          dispatch(setActiveStep(STEPPER_AUTORIZACIONES.DATOS_TITULAR));
          dispatch(setAfiliadoSeleccionado(afiliado));
        }
        if (afiliado.sinFichaAfiliacion) {
          handleErrorApi(
            dispatch,
            null,
            "Error, datos de afiliados incompletos",
            "Datos de afiliación incompletos, por favor comunicarse con Afiliaciones Ospedyc",
          );
        }
      } else {
        limpiarComponente();
      }
    }
    else {
      props.setAfiInexistente();
      props.setAfiliadoTemp(afiliado);
      props.setEnableCheckAfiInexistente(false);
    }
  };

  useEffect(() => {
    let active = true;
    (async () => {
      let texto = textoBuscado.replace("/", "__");
      if (texto.length > 0) {
        const response = await fetchConToken(
          `Afiliados/traerPorNombreoDNIoNroAfi/${texto}/${tipoBusqueda}/${altaBaja}`
        );
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const lista = await response.json();
          if (active && lista.length > 0) {
            setOptions(
              Object.keys(lista).map((id_afiliado) => lista[id_afiliado])
            );
          }
        }
      }
    })();
    return () => {
      active = false;
    };
    // eslint-disable-next-line
  }, [textoBuscado]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  const limpiarComponente = () => {
    if (props.integracion)
      dispatch(cleanAfiliadoSeleccionadoDiscapacidad());
    else if (props.adicciones)
      dispatch(cleanAfiliadoSeleccionadoAdicciones());
    else
      dispatch(cleanAfiliadoSeleccionado());

    setOptions([]);
  };

  return (
    <React.Fragment>
      <Grid
        container
        spacing={3}
        style={{
          display: "flex",
          justifyContent: !props.hideTitle ? "center" : "",
          marginTop: (props.integracion || props.adicciones) && !props.gestion && 10
        }}
      >
        {!props.hideTitle &&
          <Grid item xs={1} style={{ display: "flex", alignItems: "center" }}>
            <Typography
              component="h1"
              variant="h5"
              style={{
                color: "#FAFAFA",
              }}
            >
              Buscar
            </Typography>
          </Grid>
        }
        <Grid item xs={!props.hideTitle ? 6 : 12} style={{ flexBasis: !props.hideTitle ? "auto" : "" }}>
          <Container
            style={{
              padding: 3,
              marginTop: 5,
              margin: 5,
            }}
          >
            <Autocomplete
              id="buscadorAfiliados"
              fullWidth={!props.hideTitle ? false : true}
              style={{
                width: !props.hideTitle && 500,
                padding: 6,
                backgroundColor: "#FAFAFA",
                borderRadius: "5px",
              }}
              loadingText="Buscando..."
              disabled={props.disabled}
              value={afiliadoTemp}
              open={open}
              onOpen={() => {
                setOpen(true);
              }}
              onClose={() => {
                setOpen(false);
              }}
              onChange={(event, newValue) => {
                handleAfiliadoSeleccionado(newValue);
              }}
              getOptionSelected={(option, value) =>
                option.id_afiliado === value.id_afiliado
              }
              getOptionLabel={(option) =>
                `${option.apellido_y_nombre} ${option.carnet} ${option.cuil} ${option.nro_doc}`
              }
              renderOption={(option) => (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span
                    style={
                      option.fecha_baja === null
                        ? { color: "green" }
                        : { color: "red" }
                    }
                  >
                    {`${option.apellido_y_nombre}`}
                  </span>
                  <span
                    style={{
                      fontSize: 12,
                    }}
                  >
                    {" "}
                    {`Nro Afi:${option.carnet} - CUIL:${option.cuil}`}
                  </span>
                </div>
              )}
              options={options}
              loading={cargando}
              renderInput={(params) => (
                <TextField
                  onChange={handleInputChange}
                  style={{
                    padding: 3,
                  }}
                  {...params}
                  label="Apellido y Nombre | Nro Doc | Nro Afiliado | CUIL"
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {cargando ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          </Container>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};
